// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./js/components/Pill/Pill.css
// module id = 344
// module chunks = 0